import { defineComponent as _defineComponent } from 'vue';
import { STATES } from "./states";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StatesInfo',
    props: {
        showHelp: { type: Boolean, default: false },
        excludeStates: { type: (Array), required: false, default: () => [] },
    },
    emits: ["update:show-help", "set-filter"],
    setup(__props, { emit }) {
        const props = __props;
        const propShowHelp = computed({
            get: () => {
                return props.showHelp;
            },
            set: (val) => {
                emit("update:show-help", val);
            },
        });
        const states = STATES;
        const helpText = {
            failed: "The job failed to run.",
            ok: "The dataset has no errors.",
        };
        if (props.excludeStates) {
            for (const state of props.excludeStates) {
                delete states[state];
            }
        }
        function onFilter(value) {
            propShowHelp.value = false;
            emit("set-filter", `state:`, value);
        }
        return { __sfc: true, props, emit, propShowHelp, states, helpText, onFilter };
    }
});
